<template>
  <div class="cb-row row">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CbRow'
}
</script>
